import { Box, CircularProgress, Typography } from '@mui/material'

const LoadingSpinner = ({ message = 'Loading...', size = 40, fullScreen = false }) => {
  const content = (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={2}
    >
      <CircularProgress size={size} color="primary" />
      {message && (
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  )

  if (fullScreen) {
    return (
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{ bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(10, 14, 20, 0.8)' : 'rgba(255, 255, 255, 0.8)' }}
        zIndex={9999}
      >
        {content}
      </Box>
    )
  }

  return (
    <Box py={4} display="flex" justifyContent="center">
      {content}
    </Box>
  )
}

export default LoadingSpinner
